module.exports = __webpack_public_path__ + "img/tillys_hammer.268beae2.jpg";